import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=48286ed6&"
import script from "./Education.vue?vue&type=script&lang=ts&"
export * from "./Education.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports